/* eslint-disable prettier/prettier */
const ViewerType = {
  MULTI_VIEW: 1,
  SINGLE_VIEW: 2,
};

/**
 * Base viewer class used to display a single or multiple views.
 * Not used directly but through the SingleViewer and MultiViewer classes.
 * @ignore
 */
class BaseView {
  constructor(app) {
    this.currentPageNumber = 1;
    this.type = ViewerType.MULTI_VIEW;
    this.tempPageNumber = 0;
    this.pdfDoc = null;
    this.pagesRotation = 0;
    this._app = app;

    this.scale = 1.0;
    this.isZoomFitToPage = false;
    this.validZoomValue = "";
    this.fitToPage = 0;
    this.currentZoomLevel = 4;
    this.maxZoomLevel = 0;
  }

  /**
   * Returns the text content of the page.
   * @param {number} pageIndex Page index of the page. Numbering starts from 0.
   * @returns {string} The text content of the page.
   * @ignore
   */
  getPageTextContent(pageIndex) {
    return this._app.pdfDocument.pages[pageIndex].getTextContent({
      normalizeWhitespace: true,
    });
  }

  getCurrentSettings() {
    return {
      currentZoomLevel: this.currentZoomLevel,
      currentPageNum: this.currentPageNumber,
      validZoomValue: this.validZoomValue,
      scale: this.scale,
      isZoomFitToPage: this.isZoomFitToPage,
      fitToPage: this.fitToPage,
      maxZoomLevel: this.maxZoomLevel,
      pdfDoc: this.pdfDoc,
      rotation: this.pagesRotation,
      tempPageNumber: this.tempPageNumber,
    };
  }

  applySettings(settings) {
    if (settings) {
      this.currentPageNumber = settings.currentPageNum;
      this.currentZoomLevel = settings.currentZoomLevel;
      this.scale = settings.scale;
      this.fitToPage = settings.fitToPage;
      this.isZoomFitToPage = settings.isZoomFitToPage;
      this.maxZoomLevel = settings.maxZoomLevel;
      this.pdfDoc = settings.pdfDoc;
      this.pagesRotation = settings.rotation;
      this.tempPageNumber = settings.tempPageNumber;
      this.validZoomValue = settings.validZoomValue;
    }
  }

  getPageView(index) {
    return this._app.pdfDocument.pages[index];
  }
}

export { BaseView, ViewerType };
